import { CUS_BUSI_OVERLAY } from "../../types";

const initialState = {
  customerBusiness: {
    customerBusinessActive: false,
    customerBusinessCount: 1,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CUS_BUSI_OVERLAY:
      return {
        ...state,
        customerBusiness: action.payload,
      };

    default:
      return state;
  }
}
